export enum Role {
  User = 1,
  OrganizationUser = 2,
  BusinessUnitAdmin = 3,
  SystemAdmin = 4,
}
